// src/pages/Dashboard.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Row, Col, Spinner } from 'react-bootstrap';
import { FaBox, FaDollarSign, FaShoppingCart } from 'react-icons/fa';



const Homepage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (!isLoggedIn) {
      navigate('/');
    }
  }, [navigate]);

 
  return (
    <div className="dashboard">
      <h2 className="my-4">Home Page</h2>
    </div>
  );
};

export default Homepage;
